import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { Addon } from "src/app/shared/models/addon.model";

import { HigherAuthService } from './higher-auth.service';
import { AuthService, AuthType } from './auth.service';

import { ConnectType } from 'src/app/shared/enums/higher.enum';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AlertService } from '../alert/alert.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VacancyService {
  apiUrl = '';
  apiUrlESP = ''
  private skills$ = new BehaviorSubject([]);
  private form$ = new BehaviorSubject({});
  private vacancy$ = new BehaviorSubject({});
  private owner$ = new BehaviorSubject([]);
  private addon$: Observable<Addon>;
  private team$ = new BehaviorSubject({});
  private refferBy$ = new BehaviorSubject([]);
  private userInfo$ = new BehaviorSubject([]);
  private hiringCompany$ = new BehaviorSubject([]);
  private groupInfo$ = new BehaviorSubject([]);
  private formInfo$ = new BehaviorSubject({ isShowMainForm: true, isEspForm: false, isShowVacancySucessBox:false, isShowVacancyEvaluationForm: false,  isShowEvalutationSucessBox: false, isShowInvitationAskBox: false, isShowProviderSelection: false});
  private evaluationSet$ = new BehaviorSubject(null);
  private saveVancancyDraft$ = new BehaviorSubject(false);
  private hiringTypeInfo$ = new BehaviorSubject({individualTypesId:[], businessTypesId:[]});
  private vacanciesJobApp$ = new BehaviorSubject([]);
  vacancyCreatePayload;

  private idenediGroupId;
  contractType = [{ id: 1, name: 'Direct Hire', value: 'DirectHire' }, { id: 2, name: 'Freelancer', value: 'Freelancer' }, { id: 3, name: 'Resource Center', value: 'resourceCenter' }, { id: 4, name: 'Service Provider', value: 'serviceProvider' }]
  workTime = [{ id: 1, name: 'Full time', value: 'FullTime' }, { id: 2, name: 'Part time', value: 'PartTime' }, { id: 3, name: 'Project Base', value: 'projectBase' }]
  presenceType = [{ id: 1, name: 'Onsite', value: 'Onsite' }, { id: 2, name: 'Online', value: 'Online' }, { id: 3, name: 'Hybrid', value: 'Hybrid' }]
  displayTypes = [{ id: 1, name: 'Range', value: 'Range' }, { id: 2, name: 'Start from', value: 'StartFrom' }, { id: 3, name: 'Up to', value: 'UpTo' }]
  publishedTime = [{ id: 1, name: 'Last 3 days', value: 'last3Days' }, { id: 2, name: 'Last 10 days', value: 'last10Days' }, { id: 3, name: 'Last 30 days', value: 'last30Days' }]
  vacancyTempWork = environment.vacancyTempWork;
  public changeClientPersona: EventEmitter<boolean> = new EventEmitter();
  public changeAgencyPersona: EventEmitter<boolean> = new EventEmitter();
  

  constructor(private http: HttpClient, private higherAuthSrevice: HigherAuthService, private authService: AuthService,
    private router: Router, private alertService: AlertService) {
    let that = this
    this.higherAuthSrevice.getHigherAuth()
      .subscribe(function (addon) {
        that.apiUrl = addon.BaseUrl + '/'
      })

    this.higherAuthSrevice.getESPAddons()
      .subscribe(function (addon) {
        that.apiUrlESP = addon?.BaseUrl + '/'
      })

    this.idenediGroupId = this.authService.idenediGroupId
  }

  private processRequest<T>(request: Observable<T>): Observable<T> {
    return request.pipe(
      catchError(err => {
        if (err.status === 403) {
          this.alertService.error("You don't have access");
          this.router.navigate(['/pages/vacancies']);
        }
        return throwError(err);
      })
    );
  }

  public get evaluationSet(): Observable<any> {
    return this.evaluationSet$.asObservable();
  }

  public setEvaluationSet(set: any) {
    this.evaluationSet$.next(set);
  }

  getPublicVacancies(pageNumber = 1, pageSize, tab: string, keyword: string = "", status?: string, ownerId?: number, expression?: string, createdDate?: string, teamIds?, orgId?, vacancyType?, areasOfSpecialty?, contractIds?, workTimeIds?, countryIds?, presenceIds?, publishedExpression?, publishedOn?, displayId?, minimumSalary?, maximumSalary?, experience?, idenediKey?, profileName?, scopeIds?) {
    let data: any = { pageNumber, pageSize, keyword, tab, status, ownerId, expression, createdDate, teamIds, orgId, idenediKey, vacancyType, contractIds, workTimeIds, countryIds, presenceIds, publishedExpression, publishedOn, displayId, minimumSalary, maximumSalary, experience, profileName, areasOfSpecialty, scopeIds }
    if (this.idenediGroupId) {
      data['groupId'] = this.authService.idenediGroupId
    }
    let userInfo = this.higherAuthSrevice.getHigherUserInfo();
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-all-public', data, this.higherAuthSrevice.getHeader()))
  }

  getPublicVacanciesV2(pageNumber = 1, pageSize, tab: string, keyword: string = "", sortBy?: string, status?: string, ownerId?: number, expression?: string, createdDate?: string, teamIds?, orgId?, vacancyType?, areasOfSpecialty?, contractIds?, workTimeIds?, countryIds?, presenceIds?, publishedExpression?, publishedOn?, displayId?, minimumSalary?, maximumSalary?, experience?, idenediKey?, profileName?, scopeIds?) {
    let data: any = { pageNumber, pageSize, keyword, tab, sortBy, status, ownerId, expression, createdDate, teamIds, orgId, idenediKey, vacancyType, contractIds, workTimeIds, countryIds, presenceIds, publishedExpression, publishedOn, displayId, minimumSalary, maximumSalary, experience, profileName, areasOfSpecialty, scopeIds }
    if (this.idenediGroupId) {
      data['groupId'] = this.authService.idenediGroupId
    }
    let userInfo = this.higherAuthSrevice.getHigherUserInfo();
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-all-public', data, this.higherAuthSrevice.getHeader()))
  }

  public getVacancies(pageNumber = 1, pageSize, tab: string, keyword: string = "", status?: string, ownerId?: number, expression?: string, createdDate?: string, publicOnly?: boolean, teamIds?, orgId?, vacancyType?, areasOfSpecialty?, contractIds?, workTimeIds?, countryIds?, presenceIds?, publishedExpression?, publishedOn?, displayId?, minimumSalary?, maximumSalary?, experience?) {
    let data: any = { pageNumber, pageSize, keyword, tab, status, ownerId, expression, createdDate, publicOnly, teamIds, orgId, vacancyType, contractIds, workTimeIds, countryIds, presenceIds, publishedExpression, publishedOn, displayId, minimumSalary, maximumSalary, experience, areasOfSpecialty }
    if (this.idenediGroupId) {
      data['groupId'] = this.authService.idenediGroupId
    }
    let userInfo = this.higherAuthSrevice.getHigherUserInfo();
    //let addons = await this.higherAuthSrevice.getHigherAuth();

    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-all-v3', data, this.higherAuthSrevice.getHeader()))

  }

  public getVacanciesV2(pageNumber = 1, pageSize, tab: string, keyword: string = "", sortBy?: string, status?: string, ownerId?: number, expression?: string, createdDate?: string, publicOnly?: boolean, teamIds?, orgId?, vacancyType?, areasOfSpecialty?, contractIds?, workTimeIds?, countryIds?, presenceIds?, publishedExpression?, publishedOn?, displayId?, minimumSalary?, maximumSalary?, experience?) {
    let data: any = { pageNumber, pageSize, keyword, tab, status, ownerId, expression, createdDate, publicOnly, teamIds, orgId, vacancyType, contractIds, workTimeIds, countryIds, presenceIds, publishedExpression, publishedOn, displayId, minimumSalary, maximumSalary, experience, areasOfSpecialty }
    if (this.idenediGroupId) {
      data['groupId'] = this.authService.idenediGroupId
    }
    let userInfo = this.higherAuthSrevice.getHigherUserInfo();
    //let addons = await this.higherAuthSrevice.getHigherAuth();

    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-all-v2', data, this.higherAuthSrevice.getHeader()))

  }

  public getVancancyCount(tab: string, keyword: string = "", status?: string, ownerId?: number, expression?: string, createdDate?: string) {
    let data: any = { keyword, tab, status, ownerId, expression, createdDate }

    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-vacancy-count', data, this.higherAuthSrevice.getHeader()));
    //return this.vacanciesCount
  }


  getOwners() {
    let userInfo = this.higherAuthSrevice.getHigherUserInfo();
    let header = new HttpHeaders().set(
      "Authorization",
      "Bearer " + userInfo.access_token
    );
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/organizationteam/get-users', { headers: header, params: { ignoreInterviewerRole: 'true' } },))

  }

  public getVancancyDetails(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/details/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  public getVancancyDetailsWithIdendiKeyAndPersona(vacancyId, idenediKey, profileName?, jobApplicationId?) {
    let groupid
    if (this.idenediGroupId) {
      groupid = this.authService.idenediGroupId
    }    
      return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/details-v2/' + vacancyId + '/' + idenediKey + (profileName ? ('/' + profileName) : '') + (groupid ? ('/' + groupid) : '') + (jobApplicationId ? ('/' + jobApplicationId) : ''), this.higherAuthSrevice.getHeader()));   
  }

  getStagesByGroup(group: string) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/jobapplicationstage/get-stages/' + group, this.higherAuthSrevice.getHeader()))
  }

  public getVacancyCandidatesCountV2(vacancyId: number, status: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-candidatescount-v2',
      { vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages }, this.higherAuthSrevice.getHeader()));
  }

  public getVacancyPublicCandidatesCount(vacancyId: number, status: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, idenediKey?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-public-candidates-count',
      { vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, idenediKey }, this.higherAuthSrevice.getHeader()));
  }

  public getVacancyCandidates(pageNumber = 1, pageSize, vacancyId: number, status, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, keyword?, createdOnExpression?: string, refferBy?: string, movedBy?: string, sortBy?: string, idenediKey?, profileName?: string, lastContactedExpression?: string, lastContacted?: string) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-candidates-v5',
      { pageNumber, pageSize, vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, keyword, createdOnExpression, refferBy, movedBy, sortBy, idenediKey, profileName, lastContacted, lastContactedExpression }, this.higherAuthSrevice.getHeader()))
  }

  public getVacancyCandidatesCount(vacancyId: number, status, idenediKey?: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, createdOnExpression?: string, refferBy?: string, movedBy?: string, sortBy?: string, profileName?: string, lastContactedExpression?: string, lastContacted?: string, closedAt?: any) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-candidatescount-v5',
      { vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, createdOnExpression, refferBy, movedBy, sortBy, idenediKey, profileName, lastContacted, lastContactedExpression, closedAt }, this.higherAuthSrevice.getHeader()));
  }

  public getVacancyCandidatesV3(pageNumber = 1, pageSize, vacancyId: number, status: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, keyword?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-candidates-v3',
      { pageNumber, pageSize, vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, keyword }, this.higherAuthSrevice.getHeader()))
  }

  public getPublicVacancyCandidates(pageNumber = 1, pageSize, vacancyId: number, status: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, keyword?, idenediKey?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-public-candidates',
      { pageNumber, pageSize, vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, keyword, idenediKey }, this.higherAuthSrevice.getHeader()))
  }

  public getInvitationKey(vacancyId, key, agencyId?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/invite-link-by-idenedi', { vacancyId, key, agencyId: agencyId }, this.higherAuthSrevice.getHeader()))
  }

  getIdenediId() {
    let idenediId = localStorage.getItem('idenedi.user.id');
    return idenediId;
  }


  getSkillsObs(): Observable<any> {
    return this.skills$.asObservable();
  }

  setSkillsObs(skills: any) {
    this.skills$.next(skills);
  }

  getFormObs(): Observable<any> {
    return this.form$.asObservable();
  }

  setFormObs(form: any) {
    this.form$.next(form);
  }

  getVacancyObs(): Observable<any> {
    return this.vacancy$.asObservable();
  }

  setVacancyObs(vacancy: any) {
    this.vacancy$.next(vacancy);
  }

  getOwnerObs(): Observable<any> {
    return this.owner$.asObservable();
  }

  setOwnerObs(owner: any) {
    this.owner$.next(owner);
  }

  public getVacancyTitleSuggestion(keywords) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/search', keywords, this.higherAuthSrevice.getHeader()));
  }

  public getSkillSuggestion(Name) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-position-skills', Name, this.higherAuthSrevice.getHeader()));
  }

  public getTeamOwnerForTeam(id) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-owners-by-teamId/' + id, this.higherAuthSrevice.getHeader()))
  }

  public updateVacancy(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/update-v3', payload, this.higherAuthSrevice.getHeader()));
  }

  public addVacancy(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/add-v3', payload, this.higherAuthSrevice.getHeader()));
  }

  public getTeam() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/organizationteam/get-all-teams', this.higherAuthSrevice.getHeader()));
  }

  public getLanguages() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/resume/language-list', this.higherAuthSrevice.getHeader()));
  }

  public getLocations() {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/location-get', {}, this.higherAuthSrevice.getHeader()));
  }

  public getEmploymentType() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/get-employment-types', this.higherAuthSrevice.getHeader()));
  }

  public getPositionLevel() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/get-position-levels', this.higherAuthSrevice.getHeader()));
  }

  public getCurrency() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/get-currencies', this.higherAuthSrevice.getHeader()));
  }

  public getAdditionalBenefits() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/get-additional-Benefits', this.higherAuthSrevice.getHeader()));
  }

  public getTeamOwnerForVacancy(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-owners/' + vacancyId, this.higherAuthSrevice.getHeader()))
  }

  public changeVacancyStatus(vacancyId, statusId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/status/update', {
      id: vacancyId,
      statusId
    }, this.higherAuthSrevice.getHeader()))
  }

  public changeVacancyStatusWithJob(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/status/update', payload, this.higherAuthSrevice.getHeader()))
  }

  public changeVacancyViewership(vacancyId, status) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/set-public', {
      vacancyId: vacancyId,
      isPublic: status
    }, this.higherAuthSrevice.getHeader()))
  }

  public getTeamByCode(code) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/organizationteam/get-by-code/' + code, this.higherAuthSrevice.getHeader()))
  }

  getTeamObs(): Observable<any> {
    return this.team$.asObservable();
  }

  setTeamObs(team: any) {
    this.team$.next(team);
  }

  public addVacancyForApproval(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/send-for-approval', payload, this.higherAuthSrevice.getHeader()));
  }

  getHigherAuth() {
    return this.higherAuthSrevice.getHigherAuth();
  }

  getHigherUserInfo() {
    return this.higherAuthSrevice.getHigherUserInfo();
  }

  setHigherUserInfo(userInfo) {
    this.higherAuthSrevice.setHigherUserInfo(userInfo);
  }


  public getMessageTemplate(type: ConnectType, vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/settingtemplate/get-by-type/' + type + '/' + vacancyId, this.higherAuthSrevice.getHeader()))
  }

  public sendMessage(type: ConnectType, vacancyId, potentialCandidateID, body, subject) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/settingtemplate/send', {
      vacancyId, potentialCandidateID, body, subject, type
    }, this.higherAuthSrevice.getHeader()))
  }

  public getInvitationText(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/vacancy/get-invitation-text/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  public getMyCandidates(pageNumber = 1, pageSize, vacancyStatus?, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, keyword?, sortBy?, idenediKey?, teamIds?, closedAt?: any) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-candidates-v4',
      { pageNumber, pageSize, vacancyStatus, lastMovedDate, expression, createdOn, createdBy, stages, keyword, idenediKey, sortBy, teamIds, closedAt }, this.higherAuthSrevice.getHeader()))
  }

  public getPublicCandidateStages(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplicationstage/get-stages-for-filter', payload, this.higherAuthSrevice.getHeader()));
  }

  public getPublicCandidateAndVacancyCount(payload) {
    if (this.idenediGroupId) {
      payload['groupId'] = this.authService.idenediGroupId
    }
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/counts', payload, this.higherAuthSrevice.getHeader()));
  }

  public getPublicVacancyStatus(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-status-for-filter', payload, this.higherAuthSrevice.getHeader()));
  }

  public getPublicCandidateStatus(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/get-status-for-filter', payload, this.higherAuthSrevice.getHeader()));
  }

  public getCandidateStatusForMyCandidate(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplicationstage/get-stages-for-filter-v2', payload, this.higherAuthSrevice.getHeader()));
  }

  public getCandidateStatusForVacancyDetail(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplicationstage/get-candidate-stages-for-filter', payload, this.higherAuthSrevice.getHeader()));
  }

  public getCreatedByForVacancyDetail(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-createdby-users/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  public getMovedBy(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-movedby-users/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  getReferedBy(vacancyId, idenediKey?) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-all-refferes/' + vacancyId + (idenediKey ? ('/' + idenediKey) : ''), this.higherAuthSrevice.getHeader()))
  }

  setRefferByObs(refferBy: any) {
    this.refferBy$.next(refferBy);
  }

  getRefferByObs(): Observable<any> {
    return this.refferBy$.asObservable();
  }

  public getVacancyStatusForVacancyDetail(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplicationstage/get-stages-by-status', payload, this.higherAuthSrevice.getHeader()));
  }

  getCompany(teamId?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/company/get', { teamId }, this.higherAuthSrevice.getHeader()));
  }

  public getContractType() {
    return this.contractType;
  }

  public getWorkTime() {
    return this.workTime;
  }

  public getPublishedTime() {
    return this.publishedTime;
  }

  public getPresenceType() {
    return this.presenceType;
  }

  public getDisplayTypes() {
    return this.displayTypes;
  }

  public setVacancyFavorite(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/set-favorite', payload, this.higherAuthSrevice.getHeader()));
    //return this.vacanciesCount
  }

  setUserInfoObs() {
    this.userInfo$.next([]);
  }

  getUserInfoObs(): Observable<any> {
    return this.userInfo$.asObservable();
  }

  public getVacancyRole(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/vacancy/get-roles/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  public getOwnerByUsage(value) {
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/organizationteam/get-users/' + value, this.higherAuthSrevice.getHeader()));
  }

  getInterviewers(vacancyId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/recruiteradmin/get-users-by-vacancyid', { vacancyId }, this.higherAuthSrevice.getHeader()))
  }

  public checkVacancyInvitationValidity(vacancyId, invitationId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/vacancy/vacancyInvitation-valid/' + vacancyId + '/' + invitationId))
  }

  createJobSeeker(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/JobSeekerAccount/add-jobseeker-profile-v2', data, this.higherAuthSrevice.getHeader()));
  }

  getCandidateProfileRecordInfo(useridenedi, esporgid, higherorgId, vacancyKey) {
    // if(this.idenediGroupId){
    //   payload['groupId'] = this.idenediGroupId
    // }
    this.idenediGroupId = this.authService.idenediGroupId

    return this.processRequest(this.http.get<any>(this.apiUrlESP + 'higher/candidateProfileRecordInfo?useridenedi=' + useridenedi + '&esporgid=' + esporgid + '&higherorgId=' + higherorgId + '&groupId=' + this.idenediGroupId + '&forvacancykey=' + vacancyKey, { headers: this.authService.buildAuthHeader(AuthType.ESP) }));

  }

  getJobApplicationAlreayExsist(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/JobSeekerAccount/jobseekeruser-alreadyExist', data, this.higherAuthSrevice.getHeader()));
  }

  getVacnacyDefinitionInfo(vacancyKey) {
    return this.processRequest(this.http.get<any>(this.apiUrlESP + 'higher/vacnacyDefinitionInfo/' + vacancyKey));
  }

  getInterviewforCandidateforVacancy(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/interviewer/get-by-candidateId', data, this.higherAuthSrevice.getHeader()));
  }

  getVacancySubmissionFormESP(jobApplicationId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/jobapplication/get-espvacancyprofileId/' + jobApplicationId, this.higherAuthSrevice.getHeader()));
  }


  getResumeDetailForVacancy(resumeId, jobApplicationId?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/get-by-id-v2', { id: resumeId, jobApplicationId: jobApplicationId }, this.higherAuthSrevice.getHeader()))
  }

  getEspCandidateProfileId(candidateId, jobApplicationId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/JobSeeker/get-espCandidateProfileId/' + candidateId + '/' + jobApplicationId, this.higherAuthSrevice.getHeader()));
  }

  public vacancySetConnectedGroup(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/set-connectedgroup', payload, this.higherAuthSrevice.getHeader()));
  }

  public getCandidateProfileFormSetting(orgId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/templatesettings/jobapplication/get?OrganizationId=' + orgId, {}, this.higherAuthSrevice.getHeader()));
  }

  public checkforUniqValues(phoneNumber, linkedin, orgId, idenediKey, email?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/JobSeekerAccount/check-linkedIn-phone?OrganizationId=' + orgId + '&idenediKey=' + idenediKey + (phoneNumber ? '&phone=' + phoneNumber : '') + (linkedin ? '&linkedIn=' + linkedin : '') + (email ? '&email=' + encodeURIComponent(email) : ''), {}, this.higherAuthSrevice.getHeader()));
  }

  getProfileDefinitionInfo(higherorgId) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.get<any>(this.apiUrlESP + 'higher/profileDefinitionInfo-v2/' + higherorgId + '/' + this.idenediGroupId, { headers: this.authService.buildAuthHeader(AuthType.ESP) }));
  }

  public getNoOfOpenApplicationsForVacancy(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/JobApplication/Open-JobApplications-count/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }

  unlinkVacancyFromProject(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/Project/unlink-vacancies', data, this.higherAuthSrevice.getHeader()));
  }

  getHiringCompanyObs(): Observable<any> {
    return this.hiringCompany$.asObservable();
  }

  setHiringCompanyObs(group: any) {
    this.hiringCompany$.next(group);
  }

  getClientDefinitionInfo(useridenedi, esporgid, higherorgId) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.get<any>(this.apiUrlESP + 'higher/clientProfileRecordInfo?useridenedi=' + useridenedi + '&esporgid=' + esporgid + '&higherorgId=' + higherorgId + '&groupId=' + this.idenediGroupId, { headers: this.authService.buildAuthHeader(AuthType.ESP) }));
  }


  getVisibleProfileDataForGroup() {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.get<any>(this.apiUrl + '/api/connectedGroupSettings/get-profile-settings/' + this.idenediGroupId, this.higherAuthSrevice.getHeader()));
  }


  setGroupVacancyInfoObs(groupInfo: any) {
    this.groupInfo$.next(groupInfo);
  }

  getGroupVacancyInfoObs(): Observable<any> {
    return this.groupInfo$.asObservable();
  }

  setVacancyFormVisibilityObs(formInfo: any) {
    this.formInfo$.next(formInfo);
  }

  getVacancyFormVisibilityObs(): Observable<any> {
    return this.formInfo$.asObservable();
  }

  setSaveVancancyDraftObs(key: any) {
    this.saveVancancyDraft$.next(key);
  }

  getSaveVancancyDraftObs(): Observable<any> {
    return this.saveVancancyDraft$.asObservable();
  }

  setHiringTypeInfoObs(key: any) {
    this.hiringTypeInfo$.next(key);
  }

  getHiringTypeInfoObs(): Observable<any> {
    return this.hiringTypeInfo$.asObservable();
  }


  setVacancyPayload(payload: any) {
    this.vacancyCreatePayload = payload
  }

  getVacancyPayload() {
    return this.vacancyCreatePayload;
  }

  updateVacancyDefinition(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/save-espApplicationdata', data, this.higherAuthSrevice.getHeader()));
  }

  getVacancyShareUsers(vacancyId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/recruiteradmin/get-shareusers-by-vacancyid', { vacancyId }, this.higherAuthSrevice.getHeader()))
  }

  addSharedWithUser(vacancyId, userId: any[]) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/addVacancyUsers', { vacancyId, userId }, this.higherAuthSrevice.getHeader()))
  }

  removeSharedWithUser(vacancyId, userId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/sharewith/delete', { vacancyId, userId }, this.higherAuthSrevice.getHeader()))
  }

  addInvitationText(vacancy_InvitationText, vacancyId) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/save-invitation-text', {
      vacancy_InvitationText,
      vacancyId
    }, this.higherAuthSrevice.getHeader()))
  }

  setInvitationEnabled(vacancyId, enable: boolean) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/enableInvitation', {
      vacancyId,
      enable: enable
    }, this.higherAuthSrevice.getHeader()))
  }

  setAutoSuggestion(vacancyId, enable: boolean) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/vacancyEnableAutoSuggestion', {
      vacancyId,
      vacancyEnableAutoSuggestion: enable
    }, this.higherAuthSrevice.getHeader()))
  }


  updateVacancyRole(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/update-roles', payload, this.higherAuthSrevice.getHeader()))
  }

  vacancySetOwner(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + '/api/vacancy/setowner', payload, this.higherAuthSrevice.getHeader()));
  }

  sendOptToClient(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/organizationteam/resend-code', data, this.higherAuthSrevice.getHeader()));
  }

  verifyOptForClient(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/organizationteam/validate-code', data, this.higherAuthSrevice.getHeader()));
  }

  linkExistingResume(data: any) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/JobSeekerAccount/link-existing-resume', data, this.higherAuthSrevice.getHeader()));
  }

  resendCodeForLinking(data: any) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/resend-code', data, this.higherAuthSrevice.getHeader()));
  }

  validateCodeForLinking(data: any) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/validate-code', data, this.higherAuthSrevice.getHeader()));
  }

  vacancyUpdateRoles(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/update-roles-v2', payload, this.higherAuthSrevice.getHeader()));
  }

  getVacancyShareProvider(vacancyId, pageNumber, pageSize, searchInput: string = "") {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/agency/get-by-vacancyId', { vacancyId, pageNumber, pageSize, keyword: searchInput, groupId: this.idenediGroupId }, this.higherAuthSrevice.getHeader()))
  }

  addSharedWithProvider(vacancyId, providerInviteIds: any[], recruiterInviteIds: any[], isReInvite?) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/send-invites', { vacancyId, providerInviteIds, recruiterInviteIds, groupId: this.idenediGroupId, isReInvite }, this.higherAuthSrevice.getHeader()))
  }

  getSharedWithProviderForVacancy(vacancyId, pageNumber, pageSize, searchInput: string = "") {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/agency/get-invited-agency', { vacancyId, pageNumber, pageSize, keyword: searchInput }, this.higherAuthSrevice.getHeader()))
  }

  getNotificationSettingForGroup() {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/connectedGroupSettings/get-notification-settings/' + this.idenediGroupId, this.higherAuthSrevice.getHeader()));
  }

  getSharedWithRecruiterForVacancy(vacancyId, pageNumber, pageSize, searchInput: string = "") {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/becomerecruiter/get-invited-recruiter', { vacancyId, pageNumber, pageSize, keyword: searchInput }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyShareRecruiter(vacancyId, pageNumber, pageSize, searchInput: string = "") {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/becomerecruiter/get-by-vacancyId', { vacancyId, pageNumber, pageSize, keyword: searchInput, groupId: this.idenediGroupId }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyShareLinkPublic(vacancyId) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-shared-url', { vacancyId, groupId: this.idenediGroupId }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyShareUrl(vacancyId, data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-shared-url-v2', {
      ...data,
      vacancyId,
      groupId: this.idenediGroupId
    }, this.higherAuthSrevice.getHeader()))
  }

  sendVacancyShareUrl(vacancyId, data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/send-shared-url', {
      ...data,
      vacancyId,
      groupId: this.idenediGroupId
    }, this.higherAuthSrevice.getHeader()))
  }

  updateVacancyShareUrl(vacancyId, data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/update-sharedurl-setting', {
      ...data,
      vacancyId,
      groupId: this.idenediGroupId
    }, this.higherAuthSrevice.getHeader()))
  }

  verifyVacancyShareLinkPublic(vacancyId, key) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/verified-shared-key', { vacancyId, key }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyShareAllUser(vacancyId, pageNumber, pageSize, searchInput: string = "", vacancyInviteType) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-invite-list', { vacancyId, pageNumber, pageSize, keyword: searchInput, groupId: this.idenediGroupId, vacancyInviteType }, this.higherAuthSrevice.getHeader()))
  }

  getSharedWithAllForVacancy(vacancyId, pageNumber, pageSize, searchInput: string = "", vacancyInviteType) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-invited-list', { vacancyId, pageNumber, pageSize, keyword: searchInput, vacancyInviteType }, this.higherAuthSrevice.getHeader()))
  }

  sendPublicLink(data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/send-shared-url', { groupId: this.idenediGroupId, ...data }, this.higherAuthSrevice.getHeader()))
  }

  getSharedHistory(data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-shared-history', { groupId: this.idenediGroupId, ...data }, this.higherAuthSrevice.getHeader()))
  }

  deleteSharedHistory(data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/delete-sharedVacancy', { groupId: this.idenediGroupId, ...data }, this.higherAuthSrevice.getHeader()))
  }

  disableSharedHistory(data) {
    this.idenediGroupId = this.authService.idenediGroupId
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/disable-sharedVacancy', { groupId: this.idenediGroupId, ...data }, this.higherAuthSrevice.getHeader()))
  }

  createVacancyEvaluationSet(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/set/add-vacancy-set', data, this.higherAuthSrevice.getHeader()))
  }

  getVacancyEvaluationSet(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/set/get-vacancy-set', data, this.higherAuthSrevice.getHeader()))
  }

  getVacancyEvaluationSetCount(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/set/get-vacancyset-count', data, this.higherAuthSrevice.getHeader()))
  }

  updateVacancyEvaluationSet(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/set/update-vacancy-set', data, this.higherAuthSrevice.getHeader()))
  }

  deleteVacancyEvaluationSet(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/set/delete-vacancy-set', data, this.higherAuthSrevice.getHeader()))
  }

  getAllSkills(key) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/skill/get-all-skill/' + key, this.higherAuthSrevice.getHeader()))
  }

  getVacancyAIDescription(vacancyName: string) {
    const timestamp = new Date().getTime();
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/openAI/description', { Keyword: vacancyName }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyAIResponsibility(vacancyName: string) {
    const timestamp = new Date().getTime();
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/openAI/responsibilities', { Keyword: vacancyName }, this.higherAuthSrevice.getHeader()))
  }

  getVacancyAIRequirement(vacancyName: string) {
    const timestamp = new Date().getTime();
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/openAI/requirements', { Keyword: vacancyName }, this.higherAuthSrevice.getHeader()))
  }

  getVacancySkills(vacancyId: number) {
    return this.processRequest(this.http.get<any>(this.apiUrl + `api/skill/get-vacancy-skill/${vacancyId}`, this.higherAuthSrevice.getHeader()))
  }

  getEvaluationSet(vacancyId: number, id: number, key: string) {
    return this.processRequest(this.http.post<any>(this.apiUrl + `api/set/get-setBy-id`, { vacancyId, id, Key: key }, this.higherAuthSrevice.getHeader()))
  }

  getHigherUser(idenediKey){
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/setting/get-profile/'+idenediKey,this.higherAuthSrevice.getHeader()));
  }

  applyAsJobSeeker(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/JobSeekerAccount/add-jobseeker', data, this.higherAuthSrevice.getHeader()));
  }

  applyAsSoftware(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/software/add-job', data, this.higherAuthSrevice.getHeader()));
  }

  applyAsService(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/service/add-job', data, this.higherAuthSrevice.getHeader()));
  }

  jobAppliedStatusForVacancy(vacancyId, idenediKey) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/job-applied-status/'+vacancyId+'/'+idenediKey,  this.higherAuthSrevice.getHeader()));
  }  

  getResumeDetailForVacancyWithJobAppType(jobApplicationId?, jobApplicationType?) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/submission', {jobApplicationId: jobApplicationId,jobApplicationType:jobApplicationType }, this.higherAuthSrevice.getHeader()))
  }

  public getVacancyCandidatesv4(pageNumber = 1, pageSize, vacancyId: number, status, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, keyword?, createdOnExpression?: string, refferBy?: string, movedBy?: string, sortBy?: string, idenediKey?, profileName?: string, lastContactedExpression?: string, lastContacted?: string, agencyId?:string, jobType?:string, matchingScore?: string, evaluationScore?: string, closedAt?: any) {
      return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/get-by-vacancyId',
          { pageNumber, pageSize, vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, keyword, createdOnExpression, refferBy, movedBy, sortBy, idenediKey, profileName, lastContacted, lastContactedExpression, agencyId, jobType, matchingScore, evaluationScore, closedAt }, this.higherAuthSrevice.getHeader()))
  }


  public getVacancyCandidatesCountv4(vacancyId: number, status, idenediKey?: string, lastMovedDate?: string,
    expression?: string, createdOn?: string, createdBy?: string, stages?: string, createdOnExpression?: string, refferBy?: string, movedBy?: string, sortBy?: string, profileName?: string, lastContactedExpression?: string, lastContacted?: string, agencyId?:string, jobType?:string, matchingScore?: string, evaluationScore?: string, closedAt?: any) {
      return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/get-count-by-vacancyId',
          { vacancyId, status, lastMovedDate, expression, createdOn, createdBy, stages, createdOnExpression, refferBy, movedBy, sortBy, idenediKey, profileName, lastContacted, lastContactedExpression, agencyId, jobType, matchingScore, evaluationScore, closedAt }, this.higherAuthSrevice.getHeader()));

  }

  getAllVacancies(data) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/vacancy/get-applied-job', data, this.higherAuthSrevice.getHeader()));
  }

  getSkillSuggestions(keyword) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/skill/get-candidate-skills/'+keyword,  this.higherAuthSrevice.getHeader()));
  }

  getInviteTemplate(vacancyId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/settingtemplate/get-invite-template/'+vacancyId,  this.higherAuthSrevice.getHeader()));
  }

  getInviteCandidateInfo(jobApplicationId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/jobapplication/get-invitedCandidateId/'+jobApplicationId,  this.higherAuthSrevice.getHeader()));
  }

  getSetDetail(setId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/set/vacancy-set-by-id/' + setId, this.higherAuthSrevice.getHeader()))
  }

  getResumeMemberCommon(pageNumber = 1, pageSize, keyword: string = "", vacancyId?, isSuggested?, targetVacancyId?,evaluation?, matching?, stages?, areasOfSpecialties?, salaryCurrency?, unitForSalary?, displayId?, minimumSalary? , maximumSalary?, sortBy?, teamId? ) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/get-invited-resume', {teamId, pageNumber, pageSize, keyword, vacancyId, isSuggested, targetVacancyId, evaluation, matching, stages, areasOfSpecialties, salaryCurrency, unitForSalary, displayId, minimumSalary, maximumSalary, sortBy},this.higherAuthSrevice.getHeader()));
  }
  

  rejectApplyForVacancyInvitation(jobApplicationId, vacancyId) {    
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/JobSeekerAccount/not-interested/' + jobApplicationId + '/' + vacancyId, this.higherAuthSrevice.getHeader()));
  }


  updateSendJobOffer(payload) {
    payload['groupId'] = this.authService.idenediGroupId; 

    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/update-jobOffer', payload,this.higherAuthSrevice.getHeader()));
  }

  replyJobOffer(payload) {
    payload['groupId'] = this.authService.idenediGroupId; 
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/jobapplication/jobOffer-action', payload,this.higherAuthSrevice.getHeader()));
  }

  setVacanciesJobAppObs(refferBy: any) {
    this.vacanciesJobApp$.next(refferBy);
  }

  getVacanciesJobAppObs(): Observable<any> {
    return this.vacanciesJobApp$.asObservable();
  }  

  getVacanciesForJobApplication(keyword,filterType?) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/vacancy/get-by-higherJobapplication'+ (filterType ? ('?filterType='+filterType) : ''  ),this.higherAuthSrevice.getHeader()))
  }

  getCreatedByForHigherUser() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-createdby-users/0', this.higherAuthSrevice.getHeader()))
  }

  getTeams() {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/organizationteam/get-vacancy-teams-for-filter', this.higherAuthSrevice.getHeader()))
  }

  getOwnersForTeam(teamId) {
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/recruiteradmin/get-vacancy-owners/'+teamId, this.higherAuthSrevice.getHeader()))
  }

  getBusinessUnit(businesUnitKey) {
    let buId = businesUnitKey;
    if(typeof businesUnitKey === 'object' && businesUnitKey?.Idenedi){
      buId = businesUnitKey.Idenedi
    }
    return this.processRequest(this.http.get<any>(this.apiUrl + 'api/businessUnit/get/'+buId, this.higherAuthSrevice.getHeader()))
  }


  getAllSkillsByPage(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/skill/get-all',payload, this.higherAuthSrevice.getHeader()))
  }

  

  exportResumes(pageNumber = 1, pageSize, keyword: string = "", createdBy?, areasOfSpecialties?, salaryCurrency?, unitForSalary?, displayId?, minimumSalary? , maximumSalary?,resumeTypes?, languages?, availabilityType?, availabilityDaysAfterOffer?, availableOnAfterDate?, availableTillDate?, experience?, locationIds?, skillIds?, profileType?, profileIds?, stages?, vacancyIds?, closedAt?, isFavorite? ) {

    this.processRequest(this.http.post(this.apiUrl + 'api/resume/export-list', {pageNumber, pageSize, keyword, createdBy, areasOfSpecialties, salaryCurrency, unitForSalary, displayId, minimumSalary, maximumSalary, resumeTypes, languages, availabilityType, availabilityDaysAfterOffer, availableOnAfterDate, availableTillDate, experience, locationIds, skillIds, profileType, profileIds, stages, vacancyIds, closedAt, isFavorite}, {
      ...this.higherAuthSrevice.getHeader(),
      responseType: 'blob'
    }
    )).subscribe(response => this.downLoadFile(response, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'resumes'))
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  
  validateExistingResume(payload) {
    return this.processRequest(this.http.post<any>(this.apiUrl + 'api/resume/validate-existing-resume',payload, this.higherAuthSrevice.getHeader()))
  }
}

